'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = text;

var _actions = require('./actions');

var _util = require('@its/util');

function text() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { visible: false };
  var action = arguments[1];

  switch (action.type) {
    case _actions.SET_LOADER_VISIBILITY:
      return (0, _util.merge)(state, { visible: action.payload });
    default:
      return state;
  }
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Container components/LoadingContainer/reducer.js
 ** module id = 474
 ** module chunks = 0
 **/